export class verifyLogin {
    password: string
    username: string
}
export class completeSignUp {
    category: string
    email: string
    password: string
    token: string
}
export class resetPassword {
    email: string
    newpassword: string
    tokens: string
}

export class addUser {
    appcode: string
    auth_url: string
    category: string
    clientid: string
    contactemail: string
    createdby: number
    designation: string
    designationid: number
    fullname: string
    id: number
    location: string
    locationcode: string
    phone: string
    roles: roleList[]
    roletypes: string
    supervisor: number
    username: string
}

export class roleList {
    appcode: string
    canadd: number
    canapprove: number
    canauthorize: number
    cancheck: number
    candelete: number
    canedit: number
    canexport: number
    canprint: number
    roleid: number
    userid: number
}

export class changePassword{
    newpassword: string
    password: string
    username: string
  }

